import { Mail01, Send03 } from "@velaro/velaro-component-lib";
import { Dataflow04 } from "@velaro/velaro-component-lib";
import { UserPlus01 } from "@velaro/velaro-component-lib";
import { FlipBackward } from "@velaro/velaro-component-lib";
import { Robot } from "@velaro/velaro-component-lib";
import { MessageQuestionSquare } from "@velaro/velaro-component-lib";
import { MessageCheckSquare } from "@velaro/velaro-component-lib";
import { Link02 } from "@velaro/velaro-component-lib";
import { Data } from "@velaro/velaro-component-lib";
import { Play } from "@velaro/velaro-component-lib";
import { SvgIcon } from "@/types";
import IconEmail from "@/icons/IconEmail";
import IconHash from "@/icons/IconHash";
import IconLink from "@/icons/IconLink";
import IconList from "@/icons/IconList";
import IconPhone from "@/icons/IconPhone";
import IconText from "@/icons/IconText";
import React from "react";
import SendMessageEditor from "./RightAside/ActionEditors/SendMessageEditor";
import ConditionEditor from "./RightAside/ActionEditors/ConditionEditor";
import AskQuestionEditor from "./RightAside/ActionEditors/AskQuestionEditor";
import JumpToEditor from "./RightAside/ActionEditors/JumpToEditor";
import HttpEditor from "./RightAside/ActionEditors/HttpEditor";
import TransferToAIEditor from "./RightAside/ActionEditors/TransferToAIEditor";
import TransferToAgentsEditor from "./RightAside/ActionEditors/TransferToAgentsEditor";
import SetDataEditor from "./RightAside/ActionEditors/SetDataEditor";
import { Expression } from "@/components/Expressions/types";
import SendEmailEditor from "./RightAside/ActionEditors/SendEmailEditor";

export const nodeTypeDefs = {
  trigger: "Trigger",
  action: "Action"
};

export type NodeType = keyof typeof nodeTypeDefs;

export const triggerDefs = {
  incoming_message: "Incoming Message",
  conversation_opened: "Conversation Opened",
  conversation_resolved: "Conversation Resolved",
  visitor_opens_page: "Visitor Opens a Web Page",
  form_submitted: "Form Submitted",
  unresponsive_agent: "Unresponsive Agent",
  unresponsive_visitor: "Unresponsive Visitor",
  agent_timeout: "Agent Timeout",
  file_uploaded: "File Uploaded",
  file_downloaded: "File Downloaded",
  conversation_assigned: "Conversation Assigned To",
  vistior_left: "Visitor Left"
};

export type Trigger = keyof typeof triggerDefs;

export const premiumTriggerDefs = {
  appointment_scheduled: "Appointment Scheduled",
  service_ticket_created: "Service Ticket Created",
  visitor_returns: "Visitor Returns to the Site",
  recent_reply: "Recent Reply"
};

export const actionDefs = {
  sendMessage: {
    name: "Send Message",
    description: "Send an automated message to the conversation as a chatbot",
    icon: Send03,
    editor: SendMessageEditor
  },
  askQuestion: {
    name: "Ask Question",
    description: "Prompt the user with a specific type of question",
    icon: MessageQuestionSquare,
    editor: AskQuestionEditor
  },
  setData: {
    name: "Set Data",
    description:
      "Manually set a custom property on the workflow, conversation, or contact",
    icon: Data,
    editor: SetDataEditor
  },
  condition: {
    name: "Condition",
    description: "Create branching paths in your workflows",
    icon: Dataflow04,
    editor: ConditionEditor
  },
  httpRequest: {
    name: "HTTP Request",
    description: "Uses web requests to perform custom actions",
    icon: Link02,
    editor: HttpEditor
  },
  jumpTo: {
    name: "Jump to",
    description: "Redirects to a specific step within this workflow",
    icon: FlipBackward,
    editor: JumpToEditor
  },
  transferToAgents: {
    name: "Transfer to Agents",
    description:
      "Transfer the conversation from the workflow to agents in the current team or another team",
    icon: UserPlus01,
    editor: TransferToAgentsEditor
  },
  transferToAI: {
    name: "AI Chatbot",
    description: "Transfer the conversation from the workflow to an AI chatbot",
    icon: Robot,
    editor: TransferToAIEditor
  },
  // timeDelay: {
  //   name: "Time Delay",
  //   description: "Introduce strategic pauses into your workflow",
  //   icon: TimeDelayIcon
  // },
  closeConversation: {
    name: "Close Conversation",
    description: "Manage conversation status within your workflow",
    icon: MessageCheckSquare,
    editor: null
  },
  // addNote: {
  //   name: "Add Note",
  //   description: "Add an internal note to contacts or conversations",
  //   icon: NoteIcon
  // },
  // addTags: {
  //   name: "Add Tags",
  //   description: "Add tags to contacts or conversations",
  //   icon: TagIcon
  // },
  // sendSurvey: {
  //   name: "Send Survey",
  //   description: "Send survey",
  //   icon: ConditionIcon // reuses ConditionIcon
  // },
  // collectData: {
  //   name: "Collect Data",
  //   description: "Collect data",
  //   icon: CollectDataIcon
  // },
  // sendTranscript: {
  //   name: "Send Transcript",
  //   description: "Sends a copy of the conversation transcript to email",
  //   icon: SendTranscriptIcon
  // },
  // faq: {
  //   name: "FAQ",
  //   description: "FAQ",
  //   icon: ConditionIcon // reuses ConditionIcon
  // },
  // triggerWorkflow: {
  //   name: "Trigger Another Workflow",
  //   description: "Trigger the start of another workflow from this workflow",
  //   icon: TriggerWorkflowIcon
  // }
  sendEmail: {
    name: "Send Email",
    description: "Send an email to a specified address",
    icon: Mail01,
    editor: SendEmailEditor
  }
};

export type Action = keyof typeof actionDefs;

export function getNodeIcon(node: WorkflowNode): SvgIcon {
  if (node.type === "action") {
    return actionDefs[node.actionType].icon;
  }
  return Play;
}

export const questionDefs = {
  text: { label: "Text", icon: <IconText /> },
  number: { label: "Number", icon: <IconHash /> },
  url: { label: "URL", icon: <IconLink /> },
  phone: { label: "Phone", icon: <IconPhone /> },
  email: { label: "Email Address", icon: <IconEmail /> },
  multipleChoice: { label: "Multiple Choice", icon: <IconList /> }
  //file: { label: "File Upload", icon: <IconFilePlus /> }
};
export type Question = keyof typeof questionDefs;

export type NodeId = number;

export type WorkflowNode = {
  id: NodeId;
  type: NodeType;
  name?: string;
  description?: string;
  child?: NodeId;
} & TriggerNode &
  ActionNode &
  SendMessageNode &
  JumpToNode &
  QuestionNode &
  ConditionNode &
  HttpNode &
  TransferToAiNode &
  TransferToAgentsNode &
  SetDataNode &
  EmailNode;

export type TriggerNode = {
  trigger: Trigger;
  overrideRouting: boolean; //when this workflow is triggered, stop default routing
  channels: string[];
  triggerExpression: Expression; //parses to an Expression
};

export type ActionNode = {
  actionType: Action;
};

export type SendMessageNode = {
  text: string;
};

export type JumpToNode = {
  jumpToNodeId?: number;
};

export type QuestionNode = {
  questionType: Question;
  question: string;
  options?: NodeOption[]; //for multiple choice questions
  saveAsContactProp: boolean;
  saveAsConversationProp: boolean;
  saveAsWorkflowProp: boolean;
  propName: string;
  invalidReplyAction: "repeat" | "failBranch";
  invalidChild?: NodeId;
  characterLimit?: number;
};

export interface NodeOption {
  childNodeId?: NodeId;
  label?: string;
}

export type ConditionNode = {
  conditionOptions?: ConditionNodeOption[]; //for condition nodes
  fallbackChildId?: NodeId;
};

export interface ConditionNodeOption extends NodeOption {
  expression: Expression;
}

export const httpMethods = {
  get: "GET",
  post: "POST",
  put: "PUT",
  delete: "DELETE"
};

export type HttpNode = {
  httpMethod: keyof typeof httpMethods;
  url: string;
  headers: HttpHeader[];
  body: string;
  waitForResponse: boolean;
};

export type TransferToAiNode = {
  aiConfigId: number;
};

export type TransferToAgentsNode = {
  specificTeam: boolean;
  teamId?: number;
  specificAgent: boolean;
  agentId?: number;
};

export type SetDataNode = {
  dataToSet: WorkflowPropValue[];
  saveAsContactProp: boolean;
  saveAsConversationProp: boolean;
  saveAsWorkflowProp: boolean;
};

export type EmailNode = {
  emailTo: string;
  emailSubject: string;
  emailBody: string;
  sendTranscript: boolean;
};

export type HttpHeader = {
  key: string;
  value: string;
};

export interface NodeColors {
  bgColor: string;
  borderColor: string;
  optionColor: string;
}

export interface WorkflowPropValue {
  name: string;
  value: string;
}

export interface Workflow {
  id: number;
  name: string;
  createdBy: string;
  dateCreated: string;
  lastModified: string;
  triggerType: Trigger;
  enabled: boolean;
  nodes: Record<NodeId, WorkflowNode>;
}

export type WorkflowListItem = Omit<Workflow, "nodes">;
